export default "__VITE_ASSET__DORyWU09__"